import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { PHONE, PHONE_HREF, EMAIL, MAIN_SITE_URL } from '../../utils/constants';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-900 text-slate-400">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <img src={`${process.env.PUBLIC_URL}/sightline-logo-white.png`} alt="SightLine Networks" className="h-10 w-auto mb-4" />
            <p className="text-sm leading-relaxed">Fast, secure web hosting with managed support for Tampa Bay businesses.</p>
            <div className="mt-4 flex flex-col gap-2 text-sm">
              <a href={PHONE_HREF} className="flex items-center gap-2 hover:text-white transition">
                <Phone className="h-4 w-4" /> {PHONE}
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-white transition">
                <Mail className="h-4 w-4" /> {EMAIL}
              </a>
            </div>
          </div>

          {/* Hosting */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Hosting</h3>
            <nav className="flex flex-col gap-2.5 text-sm">
              <Link to="/plans" className="hover:text-white transition">Hosting Plans</Link>
              <Link to="/features" className="hover:text-white transition">Features</Link>
              <Link to="/plans" className="hover:text-white transition">Compare Plans</Link>
            </nav>
          </div>

          {/* Account */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Account</h3>
            <nav className="flex flex-col gap-2.5 text-sm">
              <Link to="/login" className="hover:text-white transition">Client Login</Link>
              <Link to="/register" className="hover:text-white transition">Create Account</Link>
              <Link to="/dashboard" className="hover:text-white transition">Dashboard</Link>
            </nav>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Company</h3>
            <nav className="flex flex-col gap-2.5 text-sm">
              <a href={MAIN_SITE_URL} className="hover:text-white transition">SightLine Networks</a>
              <a href={`${MAIN_SITE_URL}/#about`} className="hover:text-white transition">About Us</a>
              <a href={`${MAIN_SITE_URL}/#contact`} className="hover:text-white transition">Contact</a>
            </nav>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-800 pt-6 text-center text-xs text-slate-500">
          &copy; {new Date().getFullYear()} SightLine Networks. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
